const renting_apartment = `Hello, I am interested in renting a 1-bedroom apartment.
Could you please provide me with information about the rent and the initial deposit required?
Also, I would like to know when the apartment would be available for moving in.
Thank you for your assistance.`;
export default renting_apartment;